import {HttpClient} from '@sollapay/http-client';

import {config} from '@/app';

export interface PlacePrediction {
  placeId: string;
  text: {text: string};
  structuredFormat?: {
    mainText: {text: string};
    secondaryText?: {text: string};
  };
}

export interface AutocompleteResponse {
  suggestions?: {placePrediction?: PlacePrediction}[];
}

export interface AddressComponent {
  longText: string;
  shortText: string;
  types: string[];
}

export interface PlaceDetailsResponse {
  formattedAddress: string;
  addressComponents?: AddressComponent[];
}

// A fixed external client to Google, not the authenticated `/v1/api` useApiClient() one.
const placesClient = new HttpClient({
  baseUrl: 'https://places.googleapis.com/v1',
  headers: {'X-Goog-Api-Key': config.googleMaps.apiKey}
});

export const placesApi = {
  autocomplete: (
    input: string,
    sessionToken: string,
    languageCode: string
  ): Promise<AutocompleteResponse> =>
    placesClient.post<AutocompleteResponse>('/places:autocomplete', {
      input,
      sessionToken,
      includedRegionCodes: ['il'],
      languageCode
    }),

  getPlaceDetails: (
    placeId: string,
    sessionToken: string,
    languageCode: string
  ): Promise<PlaceDetailsResponse> =>
    placesClient.get<PlaceDetailsResponse>(`/places/${placeId}`, {
      params: {sessionToken, languageCode, regionCode: 'il'},
      headers: {'X-Goog-FieldMask': 'formattedAddress,addressComponents'}
    })
};
